import { PageHero } from "@/components/site/PageHero";
import { Reveal } from "@/components/site/Reveal";
import { COMPANY } from "@/data/content";

const content = {
  privacy: {
    eyebrow: "Legal",
    title: "Privacy Policy",
    intro:
      "This is a placeholder Privacy Policy for [COMPANY NAME]. Replace this text with your finalised policy before going live.",
    sections: [
      { h: "Information We Collect", p: "We collect the details you provide through our enquiry form, such as your name, company, email, phone and message, in order to respond to your request." },
      { h: "How We Use Information", p: "Enquiry details are used solely to respond to and manage your business enquiry. We do not sell your personal information." },
      { h: "Data Retention", p: "We retain enquiry information for as long as necessary to serve your request and for legitimate business records. [Add your retention terms.]" },
      { h: "Contact", p: "For questions about this policy, contact us at [EMAIL]." },
    ],
  },
  terms: {
    eyebrow: "Legal",
    title: "Terms & Conditions",
    intro:
      "These are placeholder Terms & Conditions for [COMPANY NAME]. Replace this text with your finalised terms before going live.",
    sections: [
      { h: "Use of Website", p: "This website is provided for general information about our sourcing and trade services. Content may be updated at any time without notice." },
      { h: "Enquiries", p: "Submitting an enquiry does not constitute a binding contract. Commercial terms are agreed separately in writing." },
      { h: "Intellectual Property", p: "All branding, text and imagery on this site are the property of their respective owners. [Add your IP terms.]" },
      { h: "Contact", p: "For questions about these terms, contact us at [EMAIL]." },
    ],
  },
};

const Legal = ({ kind = "privacy" }) => {
  const c = content[kind];
  return (
    <>
      <PageHero eyebrow={c.eyebrow} title={c.title} subtitle={c.intro} />
      <section className="bg-white py-24" data-testid={`legal-${kind}`}>
        <div className="container-x max-w-3xl space-y-10">
          {c.sections.map((s, i) => (
            <Reveal key={s.h} delay={i * 0.05}>
              <div>
                <h2 className="text-2xl font-bold text-slate-950">{s.h}</h2>
                <p className="mt-3 leading-relaxed text-slate-600">{s.p}</p>
              </div>
            </Reveal>
          ))}
          <p className="border-t border-slate-200 pt-8 text-sm text-slate-500">
            © 2026 {COMPANY.legalName}. All Rights Reserved.
          </p>
        </div>
      </section>
    </>
  );
};

export default Legal;
